import AxiosInstance from 'config/apiServiceApiGateway'

export type HandheldMonitoringUnregisterRequestType = {
  data: {
    asset_code: string
    status: string
    category_id: number
  }[]
}

export const registrationHandheldMonitoring = (data: HandheldMonitoringUnregisterRequestType) =>
  AxiosInstance.Patch<{ message: string }, true>({
    url: '/ams/internal/v1/asset-inventories',
    data,
  })
